import { App, ConfigProvider } from 'antd';
import dayjs from 'dayjs';

/**
 * Contexts
 */
import { useConfigStore } from '@/store/config';

/**
 * Resources
 */
import antdEnUS from 'antd/locale/en_US';
import antdZhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';

/**
 * Types
 */
import type { ConfigProviderProps } from 'antd';

type Props = {
    children: React.ReactNode;
};

/**
 * Constants
 */
const localeMaps = (locale: string) => {
    if (locale.includes('en')) {
        return {
            antd: antdEnUS,
            dayjs: 'en',
        };
    }

    return {
        antd: antdZhCN,
        dayjs: 'zh-cn',
    };
};

const Config: React.FC<Props> = ({ children }) => {
    /**
     * States
     */
    const { config, locale } = useConfigStore();

    /**
     * ChildrenProps
     */
    const configProps: ConfigProviderProps = {
        locale: localeMaps(locale).antd,
        ...config,
    };

    /**
     * Effects
     */
    dayjs.locale(localeMaps(locale).dayjs);

    return (
        <ConfigProvider {...configProps}>
            <App>{children}</App>
        </ConfigProvider>
    );
};

export default Config;
